// Brillenhaus – voraussichtliches Lieferdatum: zählt Werktage (Mo–Fr) ab heute und zeigt einen Zeitraum,
// z. B. "Lieferung Mi, 8. – Mo, 13. Okt.". Die Spanne kommt aus den Block-Einstellungen.
const DAY = new Intl.DateTimeFormat('de-AT', { weekday: 'short', day: 'numeric' });
const DAY_MONTH = new Intl.DateTimeFormat('de-AT', { weekday: 'short', day: 'numeric', month: 'short' });

function addWorkdays(from, days) {
  const date = new Date(from);
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) added += 1;
  }
  return date;
}

function render(el) {
  const min = Number(el.dataset.min) || 2;
  const max = Math.max(Number(el.dataset.max) || min, min);
  const now = new Date();
  const start = addWorkdays(now, min);
  const end = addWorkdays(now, max);
  const sameMonth = start.getMonth() === end.getMonth();
  const range = min === max ? DAY_MONTH.format(end) : `${(sameMonth ? DAY : DAY_MONTH).format(start)} – ${DAY_MONTH.format(end)}`;
  el.textContent = `${el.dataset.prefix || 'Lieferung'} ${range}`.replace(/\s+/g, ' ');
}

function renderAll() {
  document.querySelectorAll('.bh-buy__eta').forEach(render);
}

renderAll();
// Nach einem Variantenwechsel wird der Lagerhinweis neu eingesetzt – Datum dann erneut berechnen.
document.addEventListener('variant:update', () => setTimeout(renderAll, 0));
